<template>
  <div
    class="fcc-copy"
    :class="map === undefined ? '' : 'has-map'"
    data-aos="zoom-in-up"
    data-aos-duration="250"
    data-aos-easing="ease-out-cubic"
  >
    <div class="holder">
      <FCTitle :h2="this.h2" :h3="this.h3" />
      <div class="copy-holder">
        <slot name="copy"></slot>
      </div>
    </div>
    <img
      v-if="map !== undefined"
      class="map-special"
      :src="require(`@/assets/maps/${map}`)"
      alt
      data-aos="zoom-in-up"
      data-aos-duration="250"
      data-aos-easing="ease-out-cubic"
      @click="showPopup = true"
    />
    <FCPopup v-if="showPopup" title :image="'maps/' + map" text @close-popup="showPopup = false" />
  </div>
</template>

<script>
import FCTitle from "@/components/patterns/FCTitle";
import FCPopup from "@/components/patterns/FCShadowbox";
export default {
  components: {
    FCTitle,
    FCPopup,
  },
  props: {
    h2: String,
    h3: String,
    map: String,
  },
  data() {
    return {
      showPopup: false,
    };
  },
};
</script>

<style lang="scss" scoped>
iframe {
  width: calc(100%);
  display: none;
}
.map-special {
  position: relative;
  top: 200px;
  left: 200px;
  height: calc(100vh - 325px);
  width: calc(100vw - 800px);
  z-index: 4;
  object-fit: contain;
  object-position: top left;
}
.copy-holder {
  font-size: 1em;
  color: #ffffff;
  letter-spacing: 0;
  line-height: 1.2em;
  overflow: auto;
  max-height: calc(100vh - 160px - 65px);
  padding-right: 25px;
}
.bigger {
  font-size: 1.2em;
}
.orange {
  color: #ff5100;
}
.margin-top {
  margin-top: 20px;
}
strong {
  font-weight: bold;
}
h4 {
  margin-top: 25px;
  margin-bottom: 5px;
}
ul {
  li {
    &:not(:last-child) {
      margin-bottom: 5px;
    }
  }
}
.fcc-copy {
  &.has-map {
    z-index: 1;
  }
  &:not(.has-map) {
    &::after {
      background-image: linear-gradient(
        270deg,
        rgba(5, 17, 42, 0.84) 52%,
        rgba(0, 0, 0, 0) 100%
      );
      position: absolute;
      right: 0;
      top: 0px;
      width: 100%;
      height: 100%;
      pointer-events: none;
      content: " ";
    }
  }
  position: absolute;
  right: 0;
  top: 0;
  padding-right: 100px;
  width: 100%;
  height: 100%;
}
.holder {
  position: absolute;
  top: 175px;
  right: 0;
  margin-right: 100px;
  width: 586px;
  z-index: 1;
}
.map {
  margin-top: 50px;
  img {
    max-height: 45vh;
    max-width: 100%;
  }
}
@media (max-width: 1000px) {
  iframe {
    display: block;
  }
  .map-special {
    margin-top: 20px;
    position: static;
    width: calc(100vw);
    max-width: unset;
    object-fit: contain;
    object-position: center;
  }
  .fcc-copy {
    &::after {
      display: none;
    }
    background-image: linear-gradient(90deg, #07173a 0%, #030a18 100%);
    height: auto;
    position: static;
    overflow: auto;
    padding: 25px 0;
    width: 100%;
    box-sizing: border-box;
    .copy-holder {
      padding: 0;
      overflow: hidden;
      max-height: unset;
    }
    .map {
      text-align: center;
    }
  }
  .holder {
    max-width: 100vw;
    margin: 0 25px;
    width: calc(100% - 50px);
    position: static;
  }
}
</style>